export enum RasnFamilyStatus {
  OPEN = 'OPEN',
  IN_RECEIVING = 'IN_RECEIVING',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export interface RasnFamily {
  id: string
  partnerName: string
  status: RasnFamilyStatus
  totalRasns: number
  totalExpectedUnits: number
  totalHandledUnits: number
  created: number
  lastModified: number
}

export interface RasnFamilyMaterial {
  sku: string
  description: string
  expectedQuantity: number
  actualQuantity: number
}

export interface RasnFamilyUnit {
  sku: string
  upc: string
  quantity: number
  simpleGrade: string
  gradeReason: string
  unitHandlingStation: string
  tote: string
  receivedGoodsHolder: string
  status: string
  modifiedBy: string
  modifiedTimestamp: number
}

export interface RasnFamilyUnitForEnrichment {
  sku: string
  upc: string
  division: string
  silhouette: string
  hashable: boolean
  quantity: number
  coo: string
  grade: string
  gradeReason: string | null
  gradeReasonCode: string | null
  isegCode: string | null
  qualityCode: string | null
  unitHandlingStation: string | null
  tote: string | null
  modifiedBy: string | null
  status: string
  modifiedTimestamp: number | null
  receivedGoodsHolder: string | null
}

export interface RasnFamilyUnitsGroup {
  rasnNumber: string
  units: RasnFamilyUnitForEnrichment[]
}

export type RasnFamilyUnitsResponse = RasnFamilyUnitsGroup[]

export interface RasnFamilyRasn {
  number: string
  status: string
  holdCode: string | null
  expectedUnits: number
  handledUnits: number
  created: number
  lastModified: number
  materials: RasnFamilyMaterial[]
  units?: RasnFamilyUnit[]
}

export interface RasnFamilyEvent {
  id: number
  type: string
  timestamp: Date
  description: string
}

export interface RasnFamilyDetails {
  id: string
  partnerName: string
  status: RasnFamilyStatus
  holdCode: string | null
  totalRasns: number
  totalExpectedUnits: number
  totalHandledUnits: number
  created: number
  lastModified: number
  rasns: RasnFamilyRasn[]
  events: RasnFamilyEvent[]
  extendedAttributes: Record<string, string>
}
